/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiSnoozeConfig,
    InternalApiSnoozeConfigFromJSON,
    InternalApiSnoozeConfigToJSON,
} from '../models';

export interface AddSnoozeConfigurationsRequest {
    personId: string;
    internalApiSnoozeConfig: Array<InternalApiSnoozeConfig>;
}

export interface DeleteSnoozeConfigurationRequest {
    personId: string;
    internalApiSnoozeConfig: InternalApiSnoozeConfig;
}

/**
 * 
 */
export class PersonSnoozeApi extends runtime.BaseAPI {

    /**
     * The ID and createdTime fields are set by the server.
     * Creates new snooze configurations
     */
    async addSnoozeConfigurationsRaw(requestParameters: AddSnoozeConfigurationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling addSnoozeConfigurations.');
        }

        if (requestParameters.internalApiSnoozeConfig === null || requestParameters.internalApiSnoozeConfig === undefined) {
            throw new runtime.RequiredError('internalApiSnoozeConfig','Required parameter requestParameters.internalApiSnoozeConfig was null or undefined when calling addSnoozeConfigurations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/snooze-configurations`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.internalApiSnoozeConfig.map(InternalApiSnoozeConfigToJSON),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * The ID and createdTime fields are set by the server.
     * Creates new snooze configurations
     */
    async addSnoozeConfigurations(requestParameters: AddSnoozeConfigurationsRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.addSnoozeConfigurationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes snooze configuration, either person wide or scenario based.
     */
    async deleteSnoozeConfigurationRaw(requestParameters: DeleteSnoozeConfigurationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling deleteSnoozeConfiguration.');
        }

        if (requestParameters.internalApiSnoozeConfig === null || requestParameters.internalApiSnoozeConfig === undefined) {
            throw new runtime.RequiredError('internalApiSnoozeConfig','Required parameter requestParameters.internalApiSnoozeConfig was null or undefined when calling deleteSnoozeConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/persons/{personId}/snooze-configurations`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiSnoozeConfigToJSON(requestParameters.internalApiSnoozeConfig),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Deletes snooze configuration, either person wide or scenario based.
     */
    async deleteSnoozeConfiguration(requestParameters: DeleteSnoozeConfigurationRequest, initOverrides?: RequestInit): Promise<string> {
        const response = await this.deleteSnoozeConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
